<db-dialog-wrapper [dialog]="this" [width]="'1250px'" [fullScreenWithPadding]="true" [closeButtonRight]="'20px'" [canClose]="!loading" [hasCloseButton]="!loading">

  <db-loading-screen *ngIf="loading && !currentSubscription?.recharge" [pageBlocker]="true" ></db-loading-screen>

  <db-checkout-reseller
    [user]="user"
    [upgradeSubscriptionId]="upgradeSubscriptionId"
    [renew]="renew"
    [recharge]="currentSubscription?.recharge"
    (close)="cancel()">
  </db-checkout-reseller>
</db-dialog-wrapper>
